<template>
    <div class="w-full">
        <div class="rounded-lg grow min-h-[850px] bg-white">
            <div class="px-20 pt-10">
                <h2 class="text-gray-700 text-2xl underline">Veuillez validé le document</h2>
            </div>
            <div class="mx-auto w-[70%] rounded-lg px-7 py-8 mt-10">
                <div class="w-full flex justify-center mt-14 mb-20">
                    <img src="../../../../assets/uigb-logo.png" alt="logo uigb" class="h-20 w-auto object-cover">
                </div>
                <div class="flex justify-between">
                    <p class="mb-10 text-gray-700 text-2xl mt-10">N Ref number-Date/IUGB/PR/DAF/kmr</p>
                    <div>
                        <p class="mb-10 text-gray-700 text-2xl">Abidjan, le DATE</p>
                        <p class="mb-10 text-gray-700 text-2xl font-bold flex flex-col">
                            <span class="mb-10 ">A<br>
                                Monsieur le Directeur Général<br>
                                De la BANK name
                            </span>
                            <span class="font-normal underline">ABIDJAN</span>
                        </p>
                    </div>
                </div>
                <h2 class="text-2xl text-gray-700 mb-10"><span class="font-semibold underline">Objet</span>: Domiciliation de Salaire</h2>

                <div class="mb-10 text-gray-700 text-2xl">
                    <p class="mb-8 ml-20">
                            Monsieur le Directeur Général,
                    </p>
                    <p class="mb-10 text-justify">
                            Nous vous informons que <span class="font-bold">{{ form.nom ?? "TITLE NAME" }}</span> qui fait partie de notre personnel depuis le <span class="font-bold">{{ startDate ?? "DATE OF ENTRY" }}</span>, sous contrat à durée TYPE OF CONTRACT (DATE OF END OF CONTRACT IN CASE OF CDD) renouvelable (IN CASE OF CDD) et occupe actuellement les fonctions de POSITION vient de nous donner par écrit, en date du DATE OF REQUEST, l'ordre irrévocable d'avoir à verser à vos caisses, pour en créditer son compte BANK NAME numéro ACCOUNT NUMBER dans vos livres, toutes sommes pouvant lui être dues par notre Université, à quelque titre que ce soit, notamment son salaire net qui s'élève actuellement à <span class="font-bold"></span>NET SALARY FCFA.
                    </p>
                    <p class="mb-10">
                            Par la présente, nous nous engageons irrévocablement à exécuter ces instructions qui ne pourront être révoquées qu'avec votre accord exprès donné par écrit.
                    </p>
                    <p class="mb-10">
                            Enfin, nous nous engageons à vous aviser immédiatement de tout changement qui subviendrait dans la situation de <span class="font-bold">{{ nom ?? "TITLE NAME" }}</span> en particulier en cas de licenciement ou de saisie sur salaire. Dans cette éventualité, nous reconnaissons que nous serions tenus sous notre responsabilité de vous reverser l'intégralité des sommes dont nous pourrions être redevables envers l'intéressé à quelque titre que ce soit.
                    </p>
                    <p class="mb-16">Veuillez agréer, Monsieur le Directeur Général, nos salutations distinguées.</p>
                </div>

                <div class="text-right">
                    <p class="text-gray-700 mr-32 font-bold">SIGNATURE</p>
                </div>

                <div class="flex justify-end">
                        <div class="w-[300px] h-[150px] rounded-xl border border-dashed mt-5 flex flex-col items-center justify-center p-3">
                            <p v-if="!signature" class="font-extralight text-black">Pas de signature</p>
                            <img v-else :src="getPath" :alt="signature" class="h-full object-contain">
                        </div>
                    </div>
            </div>
            <div class="inline-flex gap-x-3 justify-center w-full mt-48">
                <button v-on:click="saveForm" class="h-14 w-32 bg-[#5357ec] text-white rounded-lg text-xl font-semibold hover:bg-[#4349d1] transition-all duration-300">
                    <Loader2 v-if="asSend" class="animate-spin mx-auto text-white"/>
                    <span v-if="!asSend">Valider</span>
                </button>
                <button class="h-14 w-32 bg-[#f44336] text-white rounded-lg text-xl font-semibold hover:bg-[#d32f2f] transition-all duration-300">
                    Refuser
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import {Loader2} from "lucide-vue-next";
import API from "@/service/API";
import toast from "@/components/ui/toast";
export default {
    name: "DomiciliationSalaireValid",
    components: {Loader2},
    data() {
        return {
            id: "",
            asSend: false,
            nom: null,
            startDate: null,
            signature: null
        };
    },
    created(){
        this.id = this.$route.params.id;
    },
    mounted() {
        this.getOneUserDocDemande();
        this.signature = localStorage.getItem("signature") ?? undefined;
    },
    computed:{
        getPath(){
            return `https://backend-ehr.iugb-ci.com/public/image/${this.signature}`;
        }
    },
    methods: {
        getOneUserDocDemande(){
            API.get("/user-docs/"+this.id)
            .then((data)=>{
                if(data.data["status"] == 'success'){
                    this.nom= JSON.parse(data.data["data"]["content"]).nom;
                    this.startDate= JSON.parse(data.data["data"]["content"]).startDate
                }
            })
            .catch(e=>{console.log(e)})
        },
        saveForm(){
            this.asSend = true;
            if(!this.signature){
                toast.error("Erreur","Veuillez enregistré votre signature à partie de votre profile",5000);
                return;
            }
            const data = {
                "validation_rh" : 1,
                "validator_id" : localStorage.getItem("userId"),
                "validator_sign" : this.signature
            }
            API.put("user-docs/"+this.id, data)
                .then((response) => {
                    if(response.data["status"] == 'success'){
                        toast.success("Succès","Demande enregistré avec succès",4000);
                    }else{
                        toast.error("Oops..",response.data["message"],4000)
                    }
                })
                .catch(() => {
                    toast.error("Oops..","Il semble avoir une erreur, merci de réessayé.",4000)
                }).finally(()=>{
                    this.asSend = false;
                });
        }
    },
}
</script>